var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hubspot_link)?_c('span',[_c('a',{staticClass:"integration-link-icon",attrs:{"href":_vm.hubspot_link,"target":"_blank","rel":"noopener noreferrer","title":"View in HubSpot"}},[_c('i',{staticClass:"fab fa-hubspot item-icon hubspot_link_icon"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }